export default __webpack_public_path__ + "static/media/dryage_thumb.edee4375.jpg";